import { GetExternalLmsAvailableDatesRequest, ExternalLmsServerDates } from '../../../typings';
import { getFetch } from '../fetch';

import { apiConfig } from '../config';

export function getExternalLmsAvailableDates(
    options: GetExternalLmsAvailableDatesRequest
): Promise<ExternalLmsServerDates> {
    const { apiGetExternalLmsAvailableDates } = apiConfig.getStaticUrls();

    return getFetch(apiGetExternalLmsAvailableDates, { ...options });
}
